export type UiLocale = 'es' | 'en'

/**
 * Español si el navegador es español (es / es-ES…); en cualquier otro caso → inglés.
 */
export function getUiLocale(): UiLocale {
  if (typeof navigator === 'undefined') return 'es'
  const primary = String(navigator.language || navigator.languages?.[0] || 'es').toLowerCase()
  return primary.startsWith('es') ? 'es' : 'en'
}

export function isSpanishUi(): boolean {
  return getUiLocale() === 'es'
}

export function isEnglishUi(): boolean {
  return getUiLocale() === 'en'
}

export type LocalizedText = { es: string; en: string }

export function pickLocalizedText(text: LocalizedText): string {
  return isEnglishUi() ? text.en : text.es
}

export function uiDateLocale(): string {
  return isEnglishUi() ? 'en-GB' : 'es-ES'
}
